<template>
  <span>
    {{ formattedTime }}
  </span>
</template>

<script>
import helper from "@/helpers/TimeZoneFormatterHelper";

export default {
  name: "TimeZoneFormatter",
  props: {
    currentTime: {
      type: [String, Number],
      default: () => {
        return null;
      },
    },
    inputFormat: {
      type: String,
      default: () => {
        return null;
      },
    },
    outputFormat: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  computed: {
    formattedTime() {
      return helper.formattedTime(
        this.currentTime,
        this.inputFormat,
        this.outputFormat
      );
    },
  },
};
</script>

<style lang="scss"></style>
